import { selectLocale } from "features/workstationSlice";
import { FC, PropsWithChildren, useEffect } from "react"
import { createIntl, createIntlCache, IntlProvider } from "react-intl";
import { useSelector } from "react-redux";
import { getMessages } from ".";

const cache = createIntlCache();

const intl = createIntl({ locale: 'en', messages: getMessages('en') }, cache);

const updateIntl = (locale: string, messages: Record<string, string>) => {
  Object.assign(intl, createIntl({ locale, messages }, cache));
};

export const I18nProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const locale = useSelector(selectLocale);
  const messages = getMessages(locale);

  useEffect(() => {
    updateIntl(locale, messages);
  }, [locale, messages]);

  return (
    <IntlProvider key={locale} locale={locale} messages={messages}>
      {children}
    </IntlProvider>
  )
}

export { intl }